import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createProgramPhase,
  getProgramPhase,
} from "@/api/program-steps";

/**
 * POST /program-phase/program/{program_id}
 * Create a program phase
 */
export const useCreateProgramPhase = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ programId, payload }: { programId: string; payload: object }) =>
      createProgramPhase(programId, payload),
    onSuccess: (_, { programId }) => {
      // Invalidate the program-phase query so that UI refreshes
      queryClient.invalidateQueries({ queryKey: ["program-phase", programId] });
    },
  });
};

/**
 * GET /program-phase/program/{program_id}
 * Get program phases for a specific program
 */
export function useGetProgramPhase(programId: string) {
  return useQuery({
    queryKey: ["program-phase", programId],
    queryFn: () => getProgramPhase(programId),
    enabled: !!programId,
  });
} 